<template>
  <b-button class="back-button" @click="goBack(returnUrl)" :aria-label="$t('common.bck')">
    <i class="fa-solid fa-arrow-left"></i>
    <!-- <span>{{ $t('common.bck') }}</span> -->
  </b-button>
</template>
<script>
/* TLV 24/09/2020 -  Component pour tous les boutons de Retour */
import {loadPage} from '@/helpers/routing'
export default {
  name: 'backButton',
  props: {
    backLabel: {
      type: Boolean,
      default: false
    },
    returnUrl: {
      type: String,
      default: 'none'
    }
  },
  methods: {
    goBack (url) {
      if (url !== 'none') {
        loadPage(this, {url: url})
      } else {
        /* On évite d'afficher la page de login a un utilisateur deja connecte */
        /* Je bidouille pour tester */
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
            loadPage(this, {url: '/home/'})
        } else {
          if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === this.$f7.mainView.history[this.$f7.mainView.history.length - 1]) {
            loadPage(this, {url: '/home/'})
          } else {
            this.$f7.mainView.router.back()
          }
          this.$bus.$emit('router-back')
        }
      }
    }
  }
}
</script>
